const formAPIRoot = () => {
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_API_URL || 'http://localhost:9970'
  } else if (process.env.REACT_APP_ENV === 'sandbox') {
    return 'https://office-api.sandbox.golfgamebook.com'
  } else if (process.env.REACT_APP_ENV === 'staging') {
    return 'https://office-api.staging.golfgamebook.com'
  } else if (process.env.REACT_APP_ENV === 'rc') {
    return 'https://office-api.rc.golfgamebook.com'
  } else if (process.env.REACT_APP_ENV === 'production') {
    return 'https://office-api.golfgamebook.com'
  } else {
    return 'http://localhost:9970'
  }
}

const formS3Url = () => {
  if (process.env.NODE_ENV === 'development') {
    return process.env.S3_URL || `https://static.staging.golfgamebook.com/`
  } else if (process.env.REACT_APP_ENV === 'sandbox') {
    return `https://static.sandbox.golfgamebook.com/`
  } else if (process.env.REACT_APP_ENV === 'staging') {
    return `https://static.staging.golfgamebook.com/`
  } else if (process.env.REACT_APP_ENV === 'rc') {
    return `https://static.rc.golfgamebook.com/`
  } else if (process.env.REACT_APP_ENV === 'production') {
    return `https://static.golfgamebook.com/`
  } else {
    return `https://static.staging.golfgamebook.com/`
  }
}

const formTmUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'https://tournament.staging.golfgamebook.com/'
  } else if (process.env.REACT_APP_ENV === 'sandbox') {
    return 'https://tournament.sandbox.golfgamebook.com/'
  } else if (process.env.REACT_APP_ENV === 'staging') {
    return 'https://tournament.staging.golfgamebook.com/'
  } else if (process.env.REACT_APP_ENV === 'rc') {
    return 'https://tournament.rc.golfgamebook.com/'
  } else if (process.env.REACT_APP_ENV === 'production') {
    return 'https://tournament.golfgamebook.com/'
  } else {
    return 'https://tournament.staging.golfgamebook.com/'
  }
}

const revenueCatEnvString = () => {
  if (process.env.NODE_ENV === 'development') {
    return '-staging'
  } else if (process.env.REACT_APP_ENV === 'production') {
    return ''
  } else {
    return `-${process.env.REACT_APP_ENV}`
  }
}

const formCognitoRedirectUri = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:3000/callback'
  } else if (process.env.REACT_APP_ENV === 'sandbox') {
    return `https://office.sandbox.golfgamebook.com/`
  } else if (process.env.REACT_APP_ENV === 'staging') {
    return `https://office.staging.golfgamebook.com/`
  } else if (process.env.REACT_APP_ENV === 'rc') {
    return `https://office.rc.golfgamebook.com/`
  } else if (process.env.REACT_APP_ENV === 'production') {
    return `https://office.golfgamebook.com/`
  } else {
    return `https://office.staging.golfgamebook.com/`
  }
}

const formCognitoLogoutRedirectUri = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:3000/logged-out'
  } else if (process.env.REACT_APP_ENV === 'sandbox') {
    return `https://office.sandbox.golfgamebook.com/logged-out`
  } else if (process.env.REACT_APP_ENV === 'staging') {
    return `https://office.staging.golfgamebook.com/logged-out`
  } else if (process.env.REACT_APP_ENV === 'rc') {
    return `https://office.rc.golfgamebook.com/logged-out`
  } else if (process.env.REACT_APP_ENV === 'production') {
    return `https://office.golfgamebook.com/logged-out`
  } else {
    return `https://office.staging.golfgamebook.com/logged-out`
  }
}

const getCognitoUserGroupPrivilege = () => {
  if (process.env.NODE_ENV !== 'development' && process.env.REACT_APP_ENV === 'production') {
    return 'azure-office-admin-production'
  }
  return 'azure-office-admin-development'
}

export const API_ROOT: string = formAPIRoot()
export const S3_URL: string = formS3Url()
export const TM_URL: string = formTmUrl()
export const COGNITO_REDIRECT_URI: string = formCognitoRedirectUri()
export const COGNITO_LOGOUT_URI: string = formCognitoLogoutRedirectUri()

export const AWS_LOGIN_URL: string = 'https://gamebook.awsapps.com/start#/'
export const AWS_CHALLENGE_RECALCULATE_URL: string =
  'https://eu-west-1.console.aws.amazon.com/systems-manager/documents/RECALCULATOR/description?region=eu-west-1'

export const USER_CHALLENGE_DEEP_LINK_BASE_URL: string = 'golfgamebook://challengeinvite'

export const LOCAL_STORAGE_LANG_KEY = `office_lang_token`
export const LOCALSTORAGE_ROUTE_NAME = `office_route`

export const SITE_TITLE = 'Golf GameBook Office'
export const TITLE_DIVIDER = ' | '

export const SITE_ADMIN_ROOT = '/admin/users'
export const SITE_USER_ROOT = '/course-editor'
export const SITE_ADMIN_COURSE_EDITOR_ROOT = '/admin/clubs'

export const SUPPORT_CONTACT_URL = 'https://support.golfgamebook.com/hc/en-us/requests/new'
export const REVENUE_CAT_URL = 'https://app.revenuecat.com/projects/9b8eab1b/customers/'
export const REVENUE_CAT_ENV_STRING = revenueCatEnvString()
export const SUPPORT_CONTACT_EMAIL = 'support@golfgamebook.com'

export const COGNITO_ADMIN: string = getCognitoUserGroupPrivilege()
export const COGNITO_GPS_EDIT_ADMIN: string = `ggb-office-gps-editor-admin`
export const COGNITO_USER: string = `ggb-office-gps-editor`

export const FI_COUNTRY_ID = 73
export const SE_COUNTRY_ID = 204

export const DEFAULT_USER_AVATAR = `${S3_URL}defaults/avatar.png`

export enum COURSE_PROVIDER {
  GGB = 'GGB',
  MGB = 'MGB',
  SGL = 'SGL',
  RFEG = 'RFEG',
  DGU = 'DGU',
  GSI = 'GSI',
}

export enum USER_MAPPING_FED_PROVIDER {
  SGL = 'uhs',
  MGB = 'sgf',
  RFEG = 'rfeg',
  DGU = 'dgu',
  GSI = 'gsi',
}

export const userProviderMap = new Map()
userProviderMap.set(USER_MAPPING_FED_PROVIDER.SGL, COURSE_PROVIDER.SGL)
userProviderMap.set(USER_MAPPING_FED_PROVIDER.MGB, COURSE_PROVIDER.MGB)
userProviderMap.set(USER_MAPPING_FED_PROVIDER.RFEG, COURSE_PROVIDER.RFEG)
userProviderMap.set(USER_MAPPING_FED_PROVIDER.DGU, COURSE_PROVIDER.DGU)
userProviderMap.set(USER_MAPPING_FED_PROVIDER.GSI, COURSE_PROVIDER.GSI)

export enum COURSE_DATA_SOURCE {
  GGB_ADMIN = 'GGB_ADMIN',
  GGB_USER = 'GGB_USER',
}

export enum TOURNAMENT_TYPE {
  USER = 'user',
  RVB = 'rvb',
  ORG = 'org',
}
